module.exports = __webpack_public_path__ + "media/images/avatar-5196682c81d7dad252a45abce0a409c0.png";